import { stageClass } from "../lib/api";

export const StageBadge = ({ stage, testid }) => {
  return (
    <span
      data-testid={testid || `stage-badge-${stage?.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider rounded-none ${stageClass(stage)}`}
    >
      {stage}
    </span>
  );
};
